import React from 'react';

import CreateAccountForm from 'components/Form/CreateAccountForm/CreateAccountForm';
import LoginForm from 'components/Form/LoginForm/LoginForm';
import CreditCardForm from 'components/Form/CreditCardForm/CreditCardForm';
import WizardForm from 'components/Form/WizardForm/WizardForm';
import SuggestionBoxForm from 'components/Form/SuggestionBoxForm/SuggestionBoxForm';

export const createAccountLayout = () => (
  <div style={{maxWidth: '408px', width: '100%'}}>
    <CreateAccountForm />
  </div>
);

export const loginLayout = () => (
  <div style={{maxWidth: '408px', width: '100%'}}>
    <LoginForm />
  </div>
);

export const creditCardLayout = () => (
  <div style={{maxWidth: '408px', width: '100%'}}>
    <CreditCardForm />
  </div>
);

export const wizardLayout = () => (
    <WizardForm
      className="main-content"
      label={{
        highlighted: 'Need Solutions?',
        text: 'Share your details with us.'
      }}
      inputs={[
        {
          placeholder: 'name',
          name: 'name',
          id: 'name',
        },
        {
          placeholder: 'email',
          name: 'email',
          id: 'email',
        },
        {
          placeholder: 'location',
          name: 'location',
          id: 'location',
        }
      ]}
    />
);

export const suggestionBoxLayout = () => (
  <SuggestionBoxForm className="main-content" />
);



// WEBPACK FOOTER //
// ./src/containers/components/Form/constants/formsLayouts.js